// extracted by css-extract-rspack-plugin
export default {"cls1":"FullScreenPremiumModal-cls1_1_9","cls2":"FullScreenPremiumModal-cls2_lko FullScreenPremiumModal-cls1_1_9"};